import { useCallback, useEffect, useState } from "react";

// State được ghi nhớ qua các lần mở trang.
//
// `revive` chạy trên giá trị đọc từ localStorage — dùng để ghép với giá trị mặc
// định và loại bỏ dữ liệu hỏng, vì bản lưu cũ có thể thiếu khoá mới thêm.
//
// Mọi thao tác đều bọc try/catch: chế độ duyệt web riêng tư trên Safari ném lỗi
// khi ghi localStorage, không nên vì thế mà sập cả trang.
export function useLocalStorage(key, initialValue, revive = v => v) {
    const [value, setValue] = useState(() => {
        try {
            const raw = window.localStorage.getItem(key);
            return raw == null ? initialValue : revive(JSON.parse(raw));
        } catch {
            return initialValue;
        }
    });

    useEffect(() => {
        try {
            window.localStorage.setItem(key, JSON.stringify(value));
        } catch {
            /* hết dung lượng hoặc bị chặn — bỏ qua, chỉ mất phần ghi nhớ */
        }
    }, [key, value]);

    // Đổi một khoá lẻ, tiện cho các bảng cài đặt dạng đối tượng.
    const setField = useCallback((field, fieldValue) => {
        setValue(prev => ({ ...prev, [field]: fieldValue }));
    }, []);

    return [value, setValue, setField];
}

export default useLocalStorage;
